import { SevenroomsVenueGroup } from '@models/venue/integrations/SevenroomsAudience'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { INTEGRATIONS_SEVENROOMS_VENUE_GROUP_URL } from '@utils/urls'

const fetchSevenroomsVenueGroups = (params: TableParams) =>
  SBAPI.FetchPaginated<SevenroomsVenueGroup[]>(
    INTEGRATIONS_SEVENROOMS_VENUE_GROUP_URL,
    params
  )

const createSevenroomsVenueGroup = (venueGroup: SevenroomsVenueGroup) =>
  SBAPI.Post(INTEGRATIONS_SEVENROOMS_VENUE_GROUP_URL, venueGroup)

export { createSevenroomsVenueGroup, fetchSevenroomsVenueGroups }
